import { oneLine } from 'common-tags/es';

const data = {
    type: 'contentpage',
    path: '/measures/health',
    meta: {
        title: 'Good health | Child Poverty',
    },
    layout: 'image-right',
    title: 'Good health',
    intro: oneLine`Children living in areas with the highest deprivation scores are <b>three times</b> more likely to 
        end up in hospital than children in areas with the lowest deprivation scores.`,
    image: {
        filename: 'Health.png',
        alt: '',
    },
    content: [
        oneLine`<p>Children living in these areas are five times more likely to be hospitalised with bronchiolitis. 
            Living in a warm dry home is important for good health.</p>`,
    ],
};

export default data;
